import React, { useState } from "react";
import { LiveAuctionCarDetail } from "@common/pages/Dashboard/components/LiveAuction/LiveAuctionCarDetaill";
import MyOrdersList from "../components/MyOrders/MyOrdersList";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
import LiveAuctionCarDetailDealer from "../components/LiveAuction/LiveAuctionCarDetaill";

const MyOrders = () => {

    // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.myOrders}/`)?.[1];

  // useState variables start...
  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);
  const [myCarsOrOtherCars, setMyCarsOrOtherCars] = React.useState(null);
  // useState variables end...

  if (Vehicle_Id && myCarsOrOtherCars !== null) {
    if (myCarsOrOtherCars === 0) {
      return <LiveAuctionCarDetail
        selectedCar={selectedCar}
        setSelectedCar={setSelectedCar}
      />;
    } else {
      return <LiveAuctionCarDetailDealer 
        selectedCar={selectedCar}
        setSelectedCar={setSelectedCar}
      />;
    }
  }
  return <MyOrdersList 
    selectedCar={selectedCar}
    setSelectedCar={setSelectedCar}
    onCarClick={(car) => {
      console.log(car, `onCarClick`)
      setSelectedCar(car);
      setDetailView(true);
      navigate(`${routes.dashboardNavigation}${routes.myOrders}/${car?.Vehicle_Id}`);
    }}
    onMyCarsOrOtherCars={(value) => {
      setMyCarsOrOtherCars(value);
    }}
  />;
};

export default MyOrders;
